import Archive from 'containers/desktop/StandingData/IdentityProvider/Archive/IdentityProviderArchive';
import Management from 'containers/desktop/StandingData/IdentityProvider/Management/IdentityProviderManagement';
import PERMISSIONS from 'enums/permissions';

export const identityProviderRoutes = [
	{
		path: '/identityProvider/archive',
		element: <Archive />,
		permissions: [PERMISSIONS.ADMINISTRATE],
	},
	{
		path: '/identityProvider/management',
		element: <Management />,
		permissions: [PERMISSIONS.ADMINISTRATE],
	},
];
